module.exports = __webpack_public_path__ + "img/3.b80e48a0.jpg";